const translations = {
  goodDay: "Good day",
  overview: "Daily operations overview",
  greeting: "Welcome back",
  // Quick stats
  todaySnapshot: "Today's Snapshot",
  todayDeliveries: "Deliveries Today",
  dueTomorrow: "Due Tomorrow",
  delayed: "Delayed",
  pendingJobCard: "Pending Job Card",
  readyForBilling: "Ready for Billing",
  // Gold position
  goldPosition: "Gold Position",
  vaultGold: "Vault Gold",
  goldWithKarigars: "Gold with Karigars",
  finishedStock: "Finished Stock",
  customerGoldHeld: "Customer Gold Held",
  totalGold: "Total Gold",
  // Orders
  orderTracking: "Order Tracking",
  openOrders: "Open Orders",
  todayBilling: "Today's Billing",
  newOrders: "New Orders (Today)",
  // Sales
  todaySales: "Today's Sales",
  weekSales: "This Week",
  monthSales: "This Month",
  cashToday: "Cash Today",
  upiToday: "UPI Today",
  // Alerts
  alerts: "Alerts & Reminders",
  overdueOrders: "Overdue Orders",
  lowStock: "Low Stock Items",
  pendingKyc: "Pending KYC",
  // Quick actions
  quickActions: "Quick Actions",
  newOrder: "New Order",
  newInvoice: "New Invoice",
  dailyClose: "Daily Close",
  goldRates: "Update Gold Rates",
  // Recent activity
  recentActivity: "Recent Activity",
  noActivity: "No recent activity.",
  // CEO view
  branchPerformance: "Branch Performance",
  allBranches: "All Branches",
  selectBranch: "Select Branch",
  totalRevenue: "Total Revenue",
  totalOrders: "Total Orders",
};

export default translations;
